import React, {
  Component,
  type ComponentType,
  type MouseEvent,
  type ReactNode,
} from 'react';
import DropDown from '../../dropDown/dropDown';
import type {
  WithDropDownOnActionDropDownProps,
  WithDropDownOnActionProps,
} from './withDropDownTypes';

export interface ComponentWithDropDownOnHoverProps {
  onMouseEnter: (event: MouseEvent) => void;
  onMouseLeave: (event: MouseEvent) => void;
  tooltip?: ReactNode;
}

const withDropDownOnHover = <P extends WithDropDownOnActionProps>(
  WrappedComponent: ComponentType<P & ComponentWithDropDownOnHoverProps>,
) => {
  class WithDropDownOnHover extends Component<
    WithDropDownOnActionProps & WithDropDownOnActionDropDownProps
  > {
    handleMouseEnter = (event: AnyFixMe) => {
      const { handlerKey, dropPanelKey } = this.props;

      this.props.openDropPanel(handlerKey || dropPanelKey);
      this.props.onMouseEnter?.(event);
    };

    handleMouseLeave = (event: AnyFixMe) => {
      this.props.closeDropPanel();
      this.props.onMouseLeave?.(event);
    };

    render() {
      const { dropPanelKey, openedDropPanel, tooltip } = this.props;
      const isOpen = dropPanelKey === openedDropPanel;

      const wrappedComponent = React.createElement(
        WrappedComponent,
        Object.assign({}, this.props as P, {
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave,
          tooltip: isOpen ? null : tooltip,
        }),
      );

      return (
        <DropDown
          isOpen={isOpen}
          delayedFadeOut={this.props.delayedFadeOut}
          onPanelMouseEnter={() => this.props.openDropPanel(dropPanelKey)}
          onPanelMouseLeave={() => this.props.closeDropPanel()}
          panelContent={this.props.dropPanelContent}
          panelTopMargin={this.props.panelTopMargin}
          panelClassName={this.props.panelClassName}
        >
          {wrappedComponent}
        </DropDown>
      );
    }
  }

  return WithDropDownOnHover;
};

export default withDropDownOnHover;
